import LoadingMiddlewareTable from './Loadingmiddleware'
import Pagination from '../../plugins/Pagination/paginationBar'
import ProductContext from '../../memory/ProductContext';
import { v4 as uuidv4 } from 'uuid';
import { motion } from 'framer-motion';
import FilteredDataProvider from '../../plugins/Filters';
import TableLoadingAnimation from '../../plugins/LoadingAnimation';


class LoadingMiddlewareAnimTable extends LoadingMiddlewareTable {
  stylingErrorDarkNess: string;

  constructor(props: any) {
    super(props);
    this.stylingTBodyComp = 'px-2 mx-4 rounded-lg shadow-md h-full';
    this.stylingErrorDarkNess = 'text-gray-700 text-opacity-50 text-base';
  }

  public override tBodyComp() {
    return (
      <tbody
        className={`${this.stylingTBodyComp}}`} key={uuidv4()}>
        {Array.from({ length: 20 }).map((_, index) => (
          <>
            <tr key={uuidv4()}>
              {Array.from({ length: 9 }).map((_, index) => (
                <td className="bg-primary" key={uuidv4()}>
                  <TableLoadingAnimation key={uuidv4()} />
                </td>
              ))}
            </tr>
          </>
        ))}
      </tbody>
    );
  }

  public override tableComp() {
    return (
      <ProductContext.Consumer>
        {(context) => (
          <div className="w-full px-8" key={uuidv4()}>
            {/* <div className="flex justify-between items-start my-4 shadow-tableShadow gap-2 pr-10 max-lg:pr-0 p-2.5"> */}
            <FilteredDataProvider />
            {/* </div> */}

            <div className="shadow-tableShadow bg-primar2">
              <div className="lg:px-6 px-5 pb-4 w-full overflow-auto rounded mxs:h-[calc(100vh-257px)] h-[calc(124vh-257px)] max-lg:pr-1 main-table">
                <table {...this.getTableProps()} className={`${this.stylingTableComp} border-collapse border-spacing-3`}>
                  {this.theadComp()}
                  {/* <Divider className='w-full'/> */}

                  {this.tBodyComp()}
                </table>
              </div>
            </div>

            <div className="ml-6">
              <Pagination initialLoad={true} jwtToken={this.props.jwtToken} />
            </div>
          </div>
        )}
      </ProductContext.Consumer>
    );
  }
}

export default LoadingMiddlewareAnimTable;
